































































































import { Component, Vue, Config, BasePage, Model, Watch, Prop } from "@/common";
@Component({})
export default class ContrEdit extends BasePage {
  @Model("change", { type: Boolean })
  private value!: boolean;

  @Watch("value")
  onValueChange(val) {
    this.showEdit = val;
  }

  @Watch("showEdit")
  onShowEditChange(val) {
    if (val === false) {
      this.resetForm("headForm");
      this.head.GUID = "";
    } else {
      if (this.propkey !== "") {
        this.dataLoading = true;
        this.$http
          .post("Biz/Contr/GetRecord", {
            GUID: this.propkey
          })
          .then(res => {
            this.dataLoading = false;
            if (res.data.status === 0) {
              Object.assign(this.head, res.data.head);
            } else {
              this.$message.warning(res.data.msg || "操作失败");
            }
          });
      }
    }
    this.$emit("change", this.showEdit);
  }

  @Watch("propkey")
  ondataLoadingChange(val) {}

  head = {
    GUID: null,
    CONTR_NO: null,
    CUSTOM_NAME: null,
    CUSTOMADRESS: null,
    BEGIN_DATE: null,
    END_DATE: null,
    CREATE_DATE: null,
    CREATE_USER: null
  };

  dataLoading = false;

  @Prop({})
  private custom!: Array<any>;

  @Prop({})
  private propkey!: String;

  showEdit = false;

  saveMask = false;

  rules = {
    BEGIN_DATE: [{ required: true, message: "请选择合同起", trigger: "blur" }],
    END_DATE: [{ required: true, message: "请选择合同止", trigger: "blur" }]
  };

  cusChange() {
    this.$http
      .get("Biz/Contr/GetAdress", {
        params: { customname: this.head.CUSTOM_NAME }
      })
      .then(res => {
        this.head.CUSTOMADRESS = res.data.addr;
      });
  }

  Save() {
    this.isFormValid("headForm", valid => {
      if (valid) {
        this.saveMask = true;
        this.$http
          .post("Biz/Contr/Save", {
            contr: this.head
          })
          .then(res => {
            if (res.data.status === 0) {
              this.saveMask = false;
              this.$message.success("保存成功");
              this.showEdit = false;
              this.$emit("on-ok");
            } else {
              this.saveMask = false;
              this.$message.warning(res.data.msg || "保存失败");
            }
          })
          .catch(err => {
            this.saveMask = false;
            this.$message.warning(err);
          });
      }
    });
  }

  mounted() {
    this.showEdit = this.value;
  }
}
